import Joi from '@hapi/joi'

export const CardSuspendRemarkSchema = {
    
    date: Joi.string().invalid("").label("Remark").required().messages({
        "any.invalid": `Need a remark`,
        "any.required": `Remark Needed`
    })

}